<div class="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#F7F9FC] to-[#EEF4FF] py-6 px-4">
    <div *ngIf="loading" class="flex justify-center items-center h-64 text-gray-500">Loading...</div>
    <div *ngIf="error" class="flex justify-center items-center h-64 text-red-500">{{error}}</div>
    <div *ngIf="!loading && !error" class="w-full max-w-sm mx-auto">
        <div class="bg-white max-w-sm rounded-2xl shadow-xl border border-gray-100 overflow-hidden">

            <!-- Header -->
            <div class="gradient-primary text-white px-4 py-3 flex items-center gap-4 relative overflow-hidden">
                <div class="absolute -top-10 -right-10 w-32 h-32 gradient-primary-overlay rounded-full"></div>
                <div
                    class="bg-white text-[#2F66FF] font-bold w-12 h-12 rounded-xl flex items-center justify-center text-lg shadow-sm">
                    <img src="../../../../assets/img/emerge-logo.png" alt="Logo" class="h-9">
                </div>
                <div>
                    <p class="text-md font-semibold leading-tight mb-1">Visitor Invitation</p>
                    <p class="text-xs opacity-90">SKH Visitor Management System</p>
                </div>
            </div>

            <div class="px-6 pb-6 pt-4">
                <p class="text-center text-gray-500 text-sm">Welcome</p>
                <p class="text-center text-lg font-semibold">{{data.nameTitle}}</p>
                <p class="text-center text-sm t-accent-foreground mt-2">
                    You are invited to visit <span class="font-semibold">{{data.desk}}</span>
                </p>

                <!-- Detail Boxes -->
                <div class="grid grid-cols-2 gap-3 mt-6">
                    <div class="flex items-start gap-3 px-2 py-1">
                        <div class="text-[#2F66FF] mt-0.5">
                            <div class="w-7 h-7 bg-icon rounded-md flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-calendar w-3.5 h-3.5 text-primary">
                                    <path d="M8 2v4"></path>
                                    <path d="M16 2v4"></path>
                                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                                    <path d="M3 10h18"></path>
                                </svg>
                            </div>
                        </div>
                        <div>
                            <p class="text-xs text-gray-500">Date</p>
                            <p class="text-xs font-regular">{{data.date | date:'EEE, MMM d, y'}}</p>
                        </div>
                    </div>

                    <div class="flex items-start gap-3 px-2 py-1">
                        <div class="text-[#2F66FF] mt-0.5">
                            <div class="w-7 h-7 bg-icon rounded-md flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-map-pin w-3.5 h-3.5 text-primary">
                                    <path
                                        d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                                    </path>
                                    <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                            </div>
                        </div>
                        <div>
                            <p class="text-xs text-gray-500">Desk</p>
                            <p class="text-xs font-regular">{{data.desk}}</p>
                        </div>
                    </div>

                    <div class="flex items-start gap-3 px-2 py-1">
                        <div class="text-[#2F66FF] mt-0.5">
                            <div class="w-7 h-7 bg-icon rounded-md flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-user w-3.5 h-3.5 text-primary">
                                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                            </div>
                        </div>
                        <div>
                            <p class="text-xs text-gray-500">Contact</p>
                            <p class="text-xs font-regular">{{data.contact}}</p>
                        </div>
                    </div>

                    <div class="flex items-start gap-3 px-2 py-1">
                        <div class="text-[#2F66FF] mt-0.5">
                            <div class="w-7 h-7 bg-icon rounded-md flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-message-square w-3.5 h-3.5 text-primary">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                </svg>
                            </div>
                        </div>
                        <div>
                            <p class="text-xs text-gray-500">Remarks</p>
                            <p class="text-xs font-regular">{{data.remarks}}</p>
                        </div>
                    </div>
                </div>

                <hr class="my-6 mb-3">

                <!-- Verification Options -->
                <p class="text-center text-gray-500 text-sm font-regular">Verification Options</p>

                <div class="bg-secondary-invi rounded-lg p-2 mb-2 mt-2">
                    <p class="text-center text-xs text-gray-500 mb-2">Use Verification PIN</p>
                    <div class="flex items-center justify-center gap-1">
                        <div *ngFor="let p of data.pin"
                            class="w-8 h-9 bg-white rounded text-center text-base font-bold text-foreground shadow-sm border border-border flex items-center justify-center">
                            {{p}}</div>
                        <div (click)="copyPin()" [title]="pinCopied ? 'Pin copied' : 'Copy PIN'"
                            class="cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 w-7 h-7 ml-1"
                            [ngClass]="pinCopied ? 'bg-green-100 hover:bg-green-100 text-green-600' : 'hover:bg-blue-100 text-muted-foreground hover:text-blue-600'">

                            <svg *ngIf="!pinCopied" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy w-3.5 h-3.5">
                                <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
                                <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
                            </svg>

                            <svg *ngIf="pinCopied" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-check w-3.5 h-3.5 text-success">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="flex items-center gap-3 my-2">
                    <div class="flex-1 h-px hr-border-bg"></div>
                    <span class="text-[12px] text-gray-500">OR</span>
                    <div class="flex-1 h-px hr-border-bg"></div>
                </div>

                <p class="text-center text-xs text-gray-500 mb-3 mt-2">Scan QR code at front desk</p>

                <!-- QR -->
                <div class="flex justify-center">
                    <div class="p-1 bg-white border rounded-xl shadow-md">
                        <img [src]="data.qrCode ? data.qrCode : 'assets/img/placeholder_qr.png'"
                            class="w-24 h-24 rounded-md">
                    </div>
                </div>

                <!-- Safety Button -->
                <div class="mt-6 warning-box rounded-lg p-2.5 flex items-center justify-between gap-2">
                    <div class="w-8 h-8 warning-box-bg-2 rounded-xl flex items-center justify-center flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-shield w-4 h-4 t-warning">
                            <path
                                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                            </path>
                        </svg>
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-xs text-gray-900">Safety Guidelines</p>
                        <p class="text-sm text-gray-600">Please read before your visit</p>
                    </div>
                    <button (click)="downloadPdf()" [disabled]="!data.guidelinePdf"
                        [class.opacity-50]="!data.guidelinePdf"
                        class="inline-flex items-center justify-center whitespace-nowrap font-regular ring-offset-background transition-colors outline-none border btn-bg-w hover:bg-accent hover:text-accent-foreground rounded-lg h-7 text-xs gap-1 px-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-download w-3.5">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" x2="12" y1="15" y2="3"></line>
                        </svg> Download
                    </button>
                </div>

                <hr class="my-3">

                <p class="text-center text-xs text-gray-500 mt-3">
                    Best regards, <span class="font-semibold text-gray-700">SKH VMS</span>
                </p>
            </div>
        </div>

        <p class="text-center text-sm text-gray-400 mt-4">
            This invitation is valid only for the specified date.
        </p>
    </div>
</div>